import { create } from 'zustand';

/** Заглушка сайта: closed — обычным игрокам вход закрыт, потому что на сайте нет администратора. */
export const useSite = create<{ closed: boolean }>(() => ({ closed: false }));

export const setSiteClosed = (closed: boolean) => useSite.setState({ closed });
